export default __webpack_public_path__ + "static/media/Weather-Application-Dashboard.75e512fa.JPG";